

// Create a class for the element
class MultiMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init(){
    this.menus = this.querySelectorAll('multi-menu-item');
    this.navItems = this.querySelectorAll('multi-menu-nav-item');
    this.menuComponents = this.querySelectorAll('multi-menu-item, multi-menu-nav-item');
    this.navItems.forEach((navItem)=>{
      navItem.onclick = ()=>{
        const menuId = navItem.getAttribute('menu');
        if(!!menuId){
          this.updateMenu(menuId);
        }
      }
    })
  }
  updateMenu(menuId){
    this.menuComponents.forEach((component)=>{
      if(component.getAttribute('menu') == menuId){
        component.setAttribute('active', '');
      } else {
        component.removeAttribute('active');
      }
    })
  }
}
customElements.define("multi-menu", MultiMenu);
